import {Search} from 'lucide-react';

import {Input} from '@/components/ui/input';
import {cn} from '@/utils/ui';

export type SearchInputProps = {
  value: string;
  onChange: (value: string) => void;
  description?: string;
  placeholder?: string;
};

const SearchInput = ({
  description,
  placeholder,
  value,
  onChange,
}: SearchInputProps) => {
  return (
    <div className="flex flex-col gap-1 w-full md:max-w-[360px]">
      <div className="relative">
        <Search className="absolute left-3 top-[50%] translate-y-[-50%] text-neutral" />
        <Input
          value={value}
          onChange={evt => {
            onChange(evt.target.value);
          }}
          className={cn(
            'pl-11 placeholder-neutral! border-neutral-200! rounded-full!'
          )}
          placeholder={placeholder || 'Search'}
        />
      </div>
      {description && <p className="text-xs text-gray-700">{description}</p>}
    </div>
  );
};

export default SearchInput;
